module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/234-australia-39ef9c78b139eb504362d6bca6cc585c.svg";